import React, { useState } from 'react';
import Header from './Header';
import Programm from './Programm';
import Org from './Org'
import News from './News';
import Speakers from './Speakers';
import Vistavka from './Vistavka';
import { Route, Routes } from 'react-router-dom';
import Help from './Help';
import Auth from './Auth';
import Nab from './Nab';
import Plan from './Plan';
import Speaker from './speaker';
import Event from './event';
import Pcomitet from './pComitet';
import Ocomitet from './oComitet';
import Lcomitet from './lComitet';


function Center (props){
   
    return(
        <div className='center'>
            <Header />
            
            <Routes  path = '/' element={<Programm sid={props.sid}/>}>
                <Route>
                <Route index path = '/' element={<Programm  sid={props.sid}/>}/>
                <Route  path = '/organization' element={<Org  sid={props.sid}/>}/>
                <Route path='/news' element={<News sid={props.sid}/>}/>
                <Route path='/Speakers' element ={<Speakers  sid={props.sid}/>}/>
                <Route path='/vistavka' element={<Vistavka sid={props.sid}/>}/>
                <Route path='/help' element={<Help sid={props.sid}/>}/>
                <Route path='/auth' element= {<Auth sid={props.sid}/>}/>
                <Route path='nabluydateliniy_sovet' element= {<Nab  sid={props.sid}/>}/>
                <Route path='programm_comitet' element= {<Pcomitet sid={props.sid}/>}/>
                <Route path = '/org_comitet' element={<Ocomitet sid={props.sid}/>} />
                <Route path = '/local_comitet' element={<Lcomitet sid={props.sid}/>}/>
                <Route path='/plan' element= {<Plan sid={props.sid}/>}/>
                <Route path='/speaker' element= {<Speaker sid={props.sid}/>}/>
                <Route path='/event' element= {<Event sid={props.sid}/>}/>
                </Route>
            </Routes>
            
            
           
            
            
            
           


        </div>






    );



}


export default Center